import { render } from "./listgroup_page.vue?vue&type=template&id=6d28b8e4&scoped=true"
import script from "./listgroup_page.vue?vue&type=script&lang=js"
export * from "./listgroup_page.vue?vue&type=script&lang=js"

import "./listgroup_page.vue?vue&type=style&index=0&id=6d28b8e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d28b8e4"]])

export default __exports__